<template>
  <v-container style="padding:4px" fill-height>
    <v-layout row align-center justify-center>
      <v-flex xs12>
        <v-card text hover class="ma-3">
          <v-card-title primary-title>
            <div class="text-center layout column about">
              <v-avatar size="100" style="margin: 0 auto">
                <img src="img/favicon.png" />
              </v-avatar>
              <div class="black--text headline">Newton App</div>
              <div class="black--text body-2">Newton Developers</div>
              <div class="black--text caption">Copyright 2019.</div>
              <div class="black--text caption">All rights reserved.</div>
            </div>
          </v-card-title>
          <v-list>
            <v-list-item
              href="mailto:gerencia@eycproveedores.com"
              target="_blank"
            >
              <v-list-item-action>
                <v-icon>mail</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <a>gerencia@eycproveedores.com</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item href="tel:+573183383072" target="_blank">
              <v-list-item-action>
                <v-icon>phone</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <a>+57 3183383072</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item href="http://eycproveedores.com" target="_blank">
              <v-list-item-action>
                <v-icon>insert_link</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <a>eycproveedores.com</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {};
</script>

<style>
.about {
  margin: 0;
  background-size: contain;
  background-repeat: repeat-x;
  background-image: url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQobcj42WvUN4l6Se3vSrvQmdQuJkH_gEs5fyW-ezWYkoMAHuqF6g");
}
</style>
